<script setup lang='ts'>
const props = withDefaults(defineProps<{
  dataList: {
    content: string
    tips?: string
  }[]
  isShowMore?: boolean
  isShowPopover?: boolean
  lineCount?: number | string
  lineHeight?: number
  gap?: number
}>(), {
  isShowMore: true,
  isShowPopover: true,
  lineCount: 2,
  lineHeight: 20,
  gap: 8,
})

const label = ref<any>(null)// 最外层容器
const more = ref<any>(null)
const showMore = ref<boolean>(false)
let nodeOffset = { // 最外层容器的位置信息
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
}
const marginBottom = ref<number>(0)
let itemRefs = reactive<any[]>([]) // item数组
let itemClient: typeof nodeOffset[] = [] // item相对于最外层容器的位置信息数组
function setItemRef(el: any) {
  if (el)
    itemRefs.push(el)
}
props.isShowMore && watch(label, (nv) => {
  (
    nodeOffset = {
      top: nv.offsetTop,
      left: nv.offsetLeft,
      bottom: nv.offsetTop + nv.offsetHeight,
      right: nv.offsetLeft + nv.offsetWidth,
    }
  )
})

!props.isShowMore && watchOnce(label, (nv) => {
  nodeOffset = {
    top: nv.offsetTop,
    left: nv.offsetLeft,
    bottom: nv.offsetTop + nv.offsetHeight,
    right: nv.offsetLeft + nv.offsetWidth,
  }
})

onBeforeUpdate(() => {
  itemRefs = []
  itemClient = []
})
onUpdated(() => {
  props.isShowMore && nextTick(() => {
    init()
  })
})

onMounted(() => {
  nextTick(() => {
    init()
  })
})
function removeHiddenElement(): void {
  if (!label.value || !label.value.childNodes[0] || !more.value)
    return

  let removeStartIndex = -1
  itemClient.forEach((v, i) => {
    if (v.bottom <= marginBottom.value)
      return

    if (removeStartIndex === -1)
      removeStartIndex = i
    label.value.childNodes?.[0] && label.value.childNodes[0].removeChild(itemRefs[i])
  })
  if (removeStartIndex === -1)
    return
  showMore.value = true
  nextTick(() => {
    if (!more.value || !itemRefs[removeStartIndex - 1]?.parentNode)
      return
    itemRefs.length = removeStartIndex // 放在nextTick前，会导致在nextTick更新后长度有变多问题
    if (more.value.offsetTop + more.value.offsetHeight - nodeOffset.bottom > marginBottom.value) { // 检测更多是否在最外层容器之外
      itemRefs[removeStartIndex - 1].parentNode.removeChild(itemRefs[removeStartIndex - 1])
    }
  })
}
function init() {
  if (itemRefs[0])
    marginBottom.value = Number.parseInt(window.getComputedStyle(itemRefs[0]).marginBottom)
  itemClient = itemRefs.map((el: any): typeof nodeOffset => {
    return {
      top: el.offsetTop - nodeOffset.top,
      left: el.offsetLeft - nodeOffset.left,
      bottom: el.offsetTop + el.offsetHeight - nodeOffset.bottom,
      right: el.offsetLeft + el.offsetWidth - nodeOffset.right,
    }
  })

  removeHiddenElement()
}
</script>

<template>
  <div
    class="label"
    :style="[`--height:${props.lineHeight}px;`, `--line:${props.lineCount};`, `--gap:${props.gap}px;`]"
  >
    <NPopover
      display-directive="show"
      :disabled="!(props.isShowPopover && showMore)" placement="bottom"
      :width="label ? label.offsetWidth : 200" trigger="hover" v-bind="$attrs"
    >
      <template #trigger>
        <div ref="label" class="label-container cursor-pointer" :class="{ 'is-none': props.lineCount === 'none' }">
          <div class="flex flex-wrap">
            <!-- {{ props.dataList }} -->
            <slot />
            <div v-for="(item, index) in props.dataList" :key="index" :ref="setItemRef" class="mb-2">
              <slot name="item" :index="index" :item="item">
                <div class="mr-2 item flex">
                  <div>{{ item.content }}</div>
                  <div v-if="item?.tips">
                    {{ item.tips }}
                  </div>
                </div>
              </slot>
            </div>
            <div v-show="showMore && props.isShowMore" ref="more" class="leading-0.5em h-5">
              ...
            </div>
          </div>
        </div>
      </template>
      <span class="flex flex-wrap label-all label">
        <span v-for="(item, index) in props.dataList" :key="index" :ref="setItemRef" class="mb-2">
          <slot name="item" :index="index" :item="item">
            <span class="mr-2 item flex">
              <span>{{ item.content === '您的诉求' ? '诉求' : item.content }}</span>
              <span v-if="item?.tips">
                {{ item.tips }}
              </span>
            </span>
          </slot>
        </span>
      </span>
    </NPopover>
  </div>
</template>

<style lang='scss' scoped>
.label {
  --height: 20px;
  --gap: 8px;
  --line: 2;
  --el-color-warning: theme('colors.orange.600');
}

.label-container {
  width: 100%;
  max-height: calc(var(--height) * var(--line) + var(--gap) * (var(--line) - 1)); //
  overflow: hidden;
}

.is-none {
  height: auto;
}

.label-all {
  width: 100%;
}

.item {
  &>* {
    font-size: 12px;
    height: 20px;
    line-height: 1.4;
    padding: 0 5px;

    &:nth-child(1) {
      background: var(--el-color-warning);
      color: #fff;
      flex-shrink: 0;
      border: 1px solid var(--el-color-warning);
    }

    &:nth-child(2) {
      border: 1px solid var(--el-color-warning);
      background: #fff;
      flex-shrink: 0;
      color: var(--el-color-warning);
    }
  }
}
</style>
